import axios from 'axios';
import { getHydratedContent } from 'Services/library/crepo.js';
import { getUserFavoritesById } from 'Services/library';
import { setAuthHeader } from 'Services/utils';
const RECOMMENDATIONS_API_URL = process.env.REACT_APP_RECOMMENDATIONS_API_URL;
const INTERESTS_RECOMMENDATIONS_API_URL =
  process.env.REACT_APP_INTERESTS_RECOMMENDATIONS_API_URL;
let recommendationsCT;

const getRecommendationsClientId = () => {
  return (
    document.cookie
      .match(/_garb=(.+?)(;|$)/)?.[1]
      .split('.')
      .slice(-2)
      .join('.') ?? 'unspecified'
  );
};

const getRecommendations = async ({
  cancelToken,
  contentIds,
  interestsBased,
  locale,
  limit = 4,
  type,
  userToken,
}) => {
  const clientId = getRecommendationsClientId();
  const productIds = contentIds.map(encodeURIComponent).join(',');
  const url = interestsBased
    ? `${INTERESTS_RECOMMENDATIONS_API_URL}?n_results=${limit}&interests=${type}&spaces=rbtv&user_experience=account&result_types=events%2Cfilms%2Cshows&localeMixingStrategy=${locale},en-INT`
    : `${RECOMMENDATIONS_API_URL}?recommendation_type=${type}&client_id=${clientId}&product_ids=${productIds}&n_results=${limit}`;
  const { data } = await axios.get(url, {
    cancelToken,
    ...setAuthHeader(userToken),
  });
  if (interestsBased) {
    let interestsBasedRecs = [];
    data.related_to_interests.map((rec) => {
      interestsBasedRecs.push(rec.id);
    });
    return interestsBasedRecs;
  }
  return data;
};

const getUserRecommendations = async ({
  cancelPreviousReq = true,
  favoritesType,
  interestsBased,
  limit = 4,
  locale,
  type,
  userId,
  userToken,
}) => {
  // If necessary (such as when changing library tabs), cancel the previous request before making a new request
  !interestsBased &&
    recommendationsCT &&
    cancelPreviousReq &&
    recommendationsCT.cancel();
  // Create a new CancelToken
  recommendationsCT = axios.CancelToken.source();

  const getContentIds = async () => {
    try {
      const { ids } = await getUserFavoritesById({
        cancelToken: recommendationsCT.token,
        filterBy: favoritesType.toLowerCase(),
        interestsBased,
        limit: 20,
        userId,
        userToken,
      });
      return ids;
    } catch (err) {
      // Ignore error from canceled request
      const isCancel = axios.isCancel(err);
      // No user favorites returns 404
      const noFavorites =
        err instanceof Error && err.response && err.response.status === 404;
      if (isCancel || noFavorites) return [];
      throw err;
    }
  };

  try {
    const contentIds = await getContentIds();
    // Get recommended resource IDs, filter out potential duplicates of favorites
    const data = (
      await getRecommendations({
        cancelToken: recommendationsCT.token,
        contentIds,
        interestsBased,
        locale,
        limit,
        type: type.toLowerCase(),
        userToken,
      })
    ).filter((id) => !contentIds.includes(id));

    // Hydrate recommended resource IDs, filter out potential geo-blocked resources
    const country = locale.split('-')[1];
    const resources = (
      await getHydratedContent({
        cancelToken: recommendationsCT.token,
        locale,
        ids: data.map((id) => `"${id}"`),
        type: favoritesType,
      })
    ).filter((resource) => !resource.geoBlockedIn.includes(country));

    return {
      resourceCount: resources.length,
      resources,
    };
  } catch (err) {
    console.log('err', err);
    // Ignore error from canceled request
    const isCancel = axios.isCancel(err);
    if (isCancel)
      return {
        resources: [],
        resourceCount: 0,
        isCancel,
      };
    throw err;
  }
};

export { getUserRecommendations };
